import { StringObject } from '@/models/GenericInterfaces'
import { SimplifiedStaticValue } from '@/models/Product'
import { StoredProperty } from '@/models/Property'
import { RegisteredTaxonomy, SimplifiedTaxonomicObject } from '@/models/Taxonomy'
import { isNumeric, toNumber, toSafeString } from '@/utils/tools'
import { RouteLocationRaw } from 'vue-router'
import { valueTypeIsNumeric } from './propertyUtils'
import { AttributeInput } from '@/models/Import'

const getTaxonomicFilterQuery = (
  taxonomy: RegisteredTaxonomy,
  taxonomyObject: SimplifiedTaxonomicObject | AttributeInput,
  term?: SimplifiedTaxonomicObject | SimplifiedStaticValue,
) => {
  const filterKey = taxonomy === 'attributes' ? `_attr_${taxonomyObject.id}` : `_${taxonomy}`
  const filterValue = term ? ('id' in term ? term.id : encodeQueryValue(term.defaultName)) : taxonomyObject.id
  return { [filterKey]: filterValue, ...getBaseProductsQuery() }
}

export const getTaxonomicFilterLink = (
  taxonomy: RegisteredTaxonomy,
  taxonomicObject: SimplifiedTaxonomicObject | AttributeInput,
  term?: SimplifiedTaxonomicObject | SimplifiedStaticValue,
  extraQuery?: StringObject,
): RouteLocationRaw => ({
  name: 'products',
  query: { ...getTaxonomicFilterQuery(taxonomy, taxonomicObject, term), ...extraQuery },
})

export const encodeQueryValue = (value: string | number | boolean | undefined) => {
  return toSafeString(value).replaceAll(',', '%2C')
}

export const decodeQueryValue = (value: string | number | boolean | undefined) => {
  return toSafeString(value).replaceAll('%2C', ',')
}

export const getFieldFilterLink = (property: StoredProperty, fieldPath: string[], value: string | number): RouteLocationRaw => {
  let filterValue = encodeQueryValue(value)
  let operator = 'equals'

  if (isNumeric(value)) {
    const num = encodeQueryValue(toNumber(value))
    if (property?.valueType && valueTypeIsNumeric(property.valueType)) {
      // default numeric props to a from/to range filter
      filterValue = [num, num].join(',')
      operator = 'range'
    }
  }

  return {
    name: 'products',
    query: { [`_field_${fieldPath.join('.')}_${operator}`]: filterValue, ...getBaseProductsQuery() },
  }
}

/**
 * includes includeAllCultures if set (originally set from taxonomy tool)
 */
export const getBaseProductsQuery = () => {
  const currentParams = new URLSearchParams(location.search)
  return currentParams.has('includeAllCultures', '1') ? { includeAllCultures: '1' } : undefined
}
